import { useState } from 'react'
import axios from 'axios'
import Swal from 'sweetalert2'
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

function TransactionForm({ onSubmitSuccess, isLoading }) {
  const [type, setType] = useState('income')
  const [amount, setAmount] = useState('')
  const [category, setCategory] = useState('')
  const [description, setDescription] = useState('')
  const [date, setDate] = useState(new Date().toISOString().split('T')[0])
const { t, i18n } = useTranslation();
 const categories = useMemo(() => ({
    income: [
      t('categories.income.sales'),
      t('categories.income.services'),
      t('categories.income.investments'),
      t('categories.income.otherIncome')
    ],
    expense: [
      t('categories.expense.rent'),
      t('categories.expense.utilities'),
      t('categories.expense.salaries'),
      t('categories.expense.supplies'),
      t('categories.expense.marketing'),
      t('categories.expense.travel'),
      t('categories.expense.otherExpenses')
    ]
  }), [i18n.language]); // <- react to language changes!
  const handleSubmit = async (e) => {
    e.preventDefault()

    const parsedAmount = parseFloat(amount)
    if (isNaN(parsedAmount) || parsedAmount <= 0) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid amount',
        text: 'Please enter a valid amount greater than zero.'
      })
      return
    }

    try {
      const payload = {
        action: type,
        amount: parsedAmount,
        description,
        category,
        date
      }

      const response = await axios.post(
        'https://trakersmallbusienss-3.onrender.com/api/auth/Dashborad',
        payload,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      )

      Swal.fire({
        icon: 'success',
        title: 'Transaction added!',
        showConfirmButton: false,
        timer: 1500
      })

      // Notify dashboard to refresh both summary and list
      if (onSubmitSuccess) {
        onSubmitSuccess(response.data.NewTransaction)
      }

      // Reset form
      setAmount('')
      setCategory('')
      setDescription('')
      setDate(new Date().toISOString().split('T')[0])
    } catch (error) {
      console.error(error)
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response?.data?.message || 'Failed to add transaction.'
      })
    }
  }

  return (
   <div className="card p-4">
  <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">{t('transactionForm.title')}</h3>

  <form onSubmit={handleSubmit} className="space-y-4">
    {/* Type Selector */}
    <div>
      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
        {t('transactionForm.transactionType')}
      </label>
      <div className="flex gap-4">
        {['income', 'expense'].map((tType) => (
          <label key={tType} className="inline-flex items-center">
            <input
              type="radio"
              name="type"
              value={tType}
              checked={type === tType}
              onChange={() => {
                setType(tType);
                setCategory('');
              }}
              className="form-radio text-blue-600"
            />
            <span className="ml-2 capitalize text-gray-700 dark:text-gray-300">{t(`transactionForm.types.${tType}`)}</span>
          </label>
        ))}
      </div>
    </div>

    {/* Amount */}
    <div>
      <label htmlFor="amount" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
        {t('transactionForm.amount')}
      </label>
      <input
        type="number"
        id="amount"
        required
        min="0.01"
        step="0.01"
        value={amount}
        onChange={(e) => setAmount(e.target.value)}
        className="input-field"
        placeholder={t('transactionForm.amountPlaceholder')}
      />
    </div>

    {/* Category */}
    <div>
      <label htmlFor="category" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
        {t('transactionForm.category')}
      </label>
      <select
        id="category"
        required
        value={category}
        onChange={(e) => setCategory(e.target.value)}
        className="input-field"
      >
        <option value="">{t('transactionForm.selectCategory')}</option>
        {categories[type].map((cat) => (
          <option key={cat} value={cat}>{cat}</option>
        ))}
      </select>
    </div>

    {/* Date */}
    <div>
      <label htmlFor="date" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
        {t('transactionForm.date')}
      </label>
      <input
        type="date"
        id="date"
        required
        value={date}
        onChange={(e) => setDate(e.target.value)}
        className="input-field"
      />
    </div>

    {/* Description */}
    <div>
      <label htmlFor="description" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
        {t('transactionForm.description')}
      </label>
      <input
        type="text"
        id="description"
        
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        className="input-field"
        placeholder={t('transactionForm.descriptionPlaceholder')}
      />
    </div>

    {/* Submit Button */}
    <div>
      <button
        type="submit"
        disabled={isLoading}
        className="btn-primary w-full"
      >
        {isLoading ? t('transactionForm.adding') : t('transactionForm.addTransaction')}
      </button>
    </div>
  </form>
</div>

  )
}

export default TransactionForm
